export default "__VITE_ASSET__BdVaD1jH__"